const useClickBoard = () => {
  return {
    copyTextToClipboard,
  };
};

export default useClickBoard;

function fallbackCopyTextToClipboard(text: string) {
  const textArea = document.createElement('textarea');
  textArea.value = text;

  // Avoid scrolling to bottom
  textArea.style.top = '0';
  textArea.style.left = '0';
  textArea.style.position = 'fixed';

  document.body.appendChild(textArea);
  textArea.focus();
  textArea.select();

  try {
    const successful = document.execCommand('copy');

    if (!successful) {
      throw new Error('Failed copying to clickBoard');
    }
  } catch {
    throw new Error('Failed copying to clickBoard');
  }

  document.body.removeChild(textArea);
}
async function copyTextToClipboard(text: string) {
  try {
    if (!navigator.clipboard) {
      fallbackCopyTextToClipboard(text);
      return [true, null] as const;
    }

    await navigator.clipboard.writeText(text);

    return [true, null] as const;
  } catch {
    return [false, 'Failed copying to clickBoard'] as [false, string];
  }
}
